<template>
  <div class="flex flex-col items-center justify-center h-full">
    <div class="my-4">
      <span v-if="success">
        Successfully connected quickbooks account
      </span>
      <span v-else-if="error">
        {{ error }}
      </span>
      <span v-else>
        Connecting quickbooks account...
      </span>
    </div>
    <router-link v-if="success" class="mt-8" to="/explorer/settings">
      <el-button type="primary">Back to Settings</el-button>
    </router-link>
    
  </div>
</template>
<script setup>
import api from "@/composables/api";
import { ref, nextTick } from "vue";
import { useUser } from "@/stores";
const userStore = useUser();

const success = ref(false)
const error = ref(null)

const callback = () => {
  api(`v1/qb/callback?url=${window.location.href}`).then((res) => {
    if (res.data && res.data.error) {
      error.value = res.data.error + ", contact support"
      return
    }
    success.value = true
  }).catch((err) => {
    // console.log("err", err);
    error.value = "Error connecting quickbooks account, contact support"
  });
}

const interval = setInterval(() => {
  nextTick(() => {
    // console.log("nextTick");
  })
  if (userStore.user) {
    callback()
    clearInterval(interval)
  }
}, 1000)

</script>